<template src="./group.html"></template>
<script>
  import Multiselect from "vue-multiselect";
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {
      Multiselect,
    },
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
    },
    data() {
      return {
        basic: {
          currentPage: 1,
          totalPages: 0,
        },
        ShowLoader: false,
        SearchForm: {
          Name: "",
        },
        GroupList: [],
        Group: {},
        ShowGroupAddModel: "",
        SubmitGroup: {},
        ShowGroupAdd: false,
        ShowGroupEdit: false,
        ShowGroupDelete: false,

        ShowGroupAssetsListModel: false,
        ShowGroupQRModel: false,
        QRCodeEndpoint : Endpoints.QR.Generate+'?content=',
        AssetsList:[],
      };
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Assets || !AccountPermissions.Assets.enable)
      ) {
        this.$router.push("/");
      }

      if (
        AccountPermissions &&
        AccountPermissions.Assets &&
        AccountPermissions.Assets.enable
      ) {
        if (AccountPermissions.Assets.add) {
          this.ShowGroupAdd = true;
        }
        if (AccountPermissions.Assets.edit) {
          this.ShowGroupEdit = true;
        }
        if (AccountPermissions.Assets.delete) {
          this.ShowGroupDelete = true;
        }
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowGroupAdd = true;
        this.ShowGroupEdit = true;
        this.ShowGroupDelete = true;
      }

      document.title = pbx_SiteTitle + " - Assets Group";
      this.GetGroupList();
    },

    methods: {
      initSubmitGroupObject() {
        this.SubmitGroup = {
          id: 0,
          name: "",
        };
      },
      GetGroupList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.name = this.SearchForm.Name;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Group.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            this.GroupList = Response.data.GroupList;
          }
        });
      },
      AddNewGroup() {
        this.ShowGroupAddModel = true;
        this.initSubmitGroupObject();
      },
      EditGroup(Group) {
        this.ShowGroupAddModel = true;
        this.SubmitGroup = {};
        this.SubmitGroup.id = Group.id;
        this.SubmitGroup.name = Group.name;
      },
      AddGroupSubmit() {
        var error = false;
        var errorStr = "";
        if (!this.SubmitGroup.name) {
          error = true;
          errorStr += "<li>Please Enter Group Name</li>";
        }
        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          this.$swal({
            title: "Adding Group...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          var postUrl = Endpoints.Assets.Group.Create;
          if (this.SubmitGroup && this.SubmitGroup.id > 0) {
            postUrl = Endpoints.Assets.Group.Update;
          }
          Axios.post(postUrl, {
            token: localStorage.getItem("token"),
            SubmitGroup: this.SubmitGroup,
          }).then((Response) => {
            if (Response.data.success == true) {
              this.ShowGroupAddModel = false;
              this.GetGroupList();
              this.initSubmitGroupObject();
              this.$swal("Group Added Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response.data.message, "", "error").then(() => {});
            }
          });
        }
      },
      DeleteGroup(Group) {
        this.$swal
          .fire({
            title: "Are you sure You want to Delete this Group?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete it!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal({
                title: "Deleting Group...",
                text: "Please wait...",
                imageUrl: require("@/assets/images/LoadingTwo.gif"),
                showConfirmButton: false,
                allowOutsideClick: false,
              });

              Axios.post(Endpoints.Assets.Group.Delete, {
                token: localStorage.getItem("token"),
                id: Group.id,
              }).then((Response) => {
                if (Response.data.success == true) {
                  this.GetGroupList();
                  this.$swal("Group Deleted Successfully", "", "success").then(
                    () => {}
                  );
                } else {
                  this.$swal(Response.data.message, "", "error").then(() => {});
                }
              });
            }
          });
      },
      ShowGroupAssetsList(GroupId) {      	
        this.ShowGroupAssetsListModel = true;
        this.$swal({
            title: "Fetching Assets List...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
        });
       	Axios.post(Endpoints.Assets.List, {
            token: localStorage.getItem("token"),
            SearchData :{'group':GroupId},
        }).then((Response) => {
            if (Response.data.success == true) {
             	this.AssetsList = Response.data.AssetsList;
              	this.$swal.close();
            }
        });        
      },
      ShowGroupQRCode(Group) {
      	this.Group = Group;
        this.ShowGroupQRModel = true;        
      },
      getGroupQRCode(group){
      	var qrurl = this.QRCodeEndpoint+btoa(group.id)
      	return qrurl;
      }
    },
  };
</script>
